export default "__VITE_ASSET__CZBBk2u8__"